export default class Progress {
  // progress = 0;
  // total = 0;
  callback = null;
  constructor(callback) {
    // this.clear();
    this.callback = callback;
  }
  log(message: string) {
    // // const p = document.createElement('p');
    // // p.classList.add('text-green-500');
    // // p.innerHTML = message;
    // // this.output.appendChild(p);
    // this.callback(this.progress, this.total, this.output);
    this.callback(message, 'text-green-500');
  }
  error(message: string) {
    // const p = document.createElement('p');
    // p.classList.add('text-red-500');
    // p.innerHTML = message;
    // this.output.appendChild(p);
    // this.callback(this.progress, this.total, this.output);
    this.callback(message, 'text-red-500');
  }
  clear() {
    // this.output = document.createElement('div');
  }
  // updateProgress(progress) {
  //   this.progress = progress;
  //   this.callback(this.progress, this.total, this.output);
  // }
}
